import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Dialog, IconButton} from 'material-ui';
import UserPasswordForm from '../../form/UserPasswordForm';
import * as userActions from '../../actions/userAction';
import {cyan400, white} from 'material-ui/styles/colors';
import CloseIcon from 'material-ui/svg-icons/navigation/close';
import {Link} from 'react-router';
import toastr from 'toastr';
import Validator from 'validatorjs';

class UserPasswordPopinContainer extends React.Component {

    updatePassword(data) {
        this.props.userActions.updatePassword(data).then(() => {
            this.context.router.goBack();
            //toastr.success('Utilisateur modifié avec succès', 'Modification d\'un utilisateur');
        });
    }

    validate(data) {
        const rules = {
            password: 'required',
            password_confirmation: 'required|same:password'
        };
        const messages = {
            required: 'Ce champ est obligatoire.',
            same: 'Les mots de passe doivent être identiques.'
        };
        let validator = new Validator(data, rules, messages);
        if (validator.fails()) {
            return validator.errors.all();
        }
        return true;
    }


    render() {
        const titleStyle = {
            padding: 10,
            margin: 0,
            backgroundColor: cyan400,
            color: white
        };
        const validate = this.validate.bind(this);
        const updatePassword = this.updatePassword.bind(this);
        const user = (this.props.user.length == 1) ? this.props.user[0] : null;
        const popinHeader = (
            <div>
                Modifier le mot de passe
                <Link to={'/user'}>
                    <IconButton style={{position: 'absolute', top: 0, right: 0}}>
                        <CloseIcon color={white}/>
                    </IconButton>
                </Link>
            </div>);
        return (
            <Dialog titleStyle={titleStyle} contentStyle={{maxWidth: 500}} open title={popinHeader}>
                <h3>{user.name}</h3>
                <UserPasswordForm {...this.props} onSubmit={updatePassword} validate={validate}/>
            </Dialog>
        );
    }
}

UserPasswordPopinContainer.propTypes = {
    userActions: PropTypes.object,
    user: PropTypes.array
};

UserPasswordPopinContainer.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {
        user: state.users.filter((user) => user.id == ownProps.routeParams.user)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        userActions: bindActionCreators(userActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserPasswordPopinContainer);


/** WEBPACK FOOTER **
 ** ./src/container/UserPasswordPopinContainer/index.js
 **/